<template>
	<div class="px-3 pt-0 pb-3">
		<!-- View Switcher -->
		<div class="promotion-toggle-container">
			<div class="promotion-toggle-pill">
				<button 
					:class="{ active: currentView === 'up' }" 
					@click="currentView = 'up'" 
					class="toggle-btn"
				>
					<span class="dot-indicator"></span>晋级1 (梯队板块)
				</button>
				<button 
					:class="{ active: currentView === 'promotion' }" 
					@click="currentView = 'promotion'" 
					class="toggle-btn"
				>
					<span class="dot-indicator"></span>晋级2 (连板详情)
				</button>
			</div>
		</div>

		<!-- Main Views -->
		<keep-alive>
			<UplimitStepWithNextDay v-if="currentView === 'up'" @show_sidebar="show_sidebar" key="up"></UplimitStepWithNextDay>
			<UplimitPromotion v-else-if="currentView === 'promotion'" @show_sidebar="show_sidebar" key="promotion"></UplimitPromotion>
		</keep-alive>

		<!-- Shared Sidebar -->
		<StockInfoSidebar :symbol_code="symbol_code" :symbol_name="symbol_name" :date_mark="date_mark" @date-mark-change="onDateMarkChange"></StockInfoSidebar>
	</div>
</template>

<script>
import UplimitStepWithNextDay from 'components/uplimit/UplimitStepWithNextDay.vue'
import UplimitPromotion from 'components/uplimit/UplimitPromotion.vue'
import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'

export default {
	name: 'ReviewUpLimitPromotion',
	data() {
		return {
			currentView: 'up', // Default to Promotion 1
			symbol_code: '603069',
			symbol_name: '',
			date_mark: ''
		}
	},
	components: {
		UplimitStepWithNextDay,
		UplimitPromotion,
		StockInfoSidebar,
	},
	methods: {
		show_sidebar(stock_info) {
			this.symbol_code = stock_info['stock_code'];
			this.symbol_name = stock_info['stock_name'];
			this.date_mark = stock_info['date1'] || this.date_mark || ''
		},
		onDateMarkChange(date) { 
			this.date_mark = date || '' 
		}
	}
}
</script>

<style scoped>
.promotion-toggle-container {
	display: flex;
	justify-content: flex-start;
	padding: 8px 4px 12px 4px;
}

.promotion-toggle-pill {
	display: flex;
	background: var(--bg-muted);
	border: 1px solid var(--border-color);
	padding: 4px;
	border-radius: 999px;
	box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}

.toggle-btn {
	border: none;
	background: transparent;
	padding: 6px 18px;
	border-radius: 999px;
	font-size: 13px;
	font-weight: 500;
	color: var(--text-muted);
	cursor: pointer;
	transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	outline: none;
	display: flex;
	align-items: center;
	gap: 6px;
}

.toggle-btn:hover {
	color: var(--text-main);
}

.toggle-btn.active {
	background: var(--bg-card);
	color: var(--accent-color);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	font-weight: 600;
}

.dot-indicator {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: transparent;
	transition: all 0.25s ease;
}

.toggle-btn.active .dot-indicator {
	background-color: var(--accent-color);
	box-shadow: 0 0 6px var(--accent-color);
}

body.theme-dark .toggle-btn.active {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

@media (max-width: 576px) {
	.toggle-btn {
		padding: 5px 12px;
		font-size: 12px;
	}
}
</style>
